<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		class="notched-arrow"
		:class="`notched-arrow--${direction}`"
		viewBox="0 0 170 260"
	>
		<g>
			<polygon
				class="notched-arrow__arrow"
				points="170 130 0 0 40 130 0 260 170 130"
			/>
		</g>
	</svg>
</template>

<script lang="ts" setup>
import { Placements } from "@/types/ui";

interface Props {
	direction: Placements;
}

const { direction = Placements.RIGHT } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.notched-arrow {
	&__arrow {
		fill: #fff3dd;
	}
}
</style>
